import {ReactNode} from 'react';
import useEmblaCarousel from 'embla-carousel-react';

type EmlbaRef = ReturnType<typeof useEmblaCarousel>;

type Props = {
  slides: ReactNode[];
  emblaRef: EmlbaRef[0];
};

const Swiper = ({slides, emblaRef}: Props) => (
  <div className="swiper__viewport" ref={emblaRef} style={{width: '100%'}}>
    <div className="swiper__container" style={{display: 'flex', height: '100%'}}>
      {slides.map((slide, index) => (
        <div key={`slide-${index}`} className="swiper__slide" style={{flex: '0 0 100%'}}>
          {slide}
        </div>
      ))}
    </div>
  </div>
);

export default Swiper;
